import { render, staticRenderFns } from "./ViewLabourerPaymentPage.vue?vue&type=template&id=768fe328&scoped=true&"
import script from "./ViewLabourerPaymentPage.vue?vue&type=script&lang=js&"
export * from "./ViewLabourerPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewLabourerPaymentPage.vue?vue&type=style&index=0&id=768fe328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768fe328",
  null
  
)

export default component.exports